import { account, databases } from "@/lib/appwrite";
import { getUserAvatarUrl } from "@/lib/storage/getAvatar";
const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
const collectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID!;

type Profile = {
  $id: string;
  userId: string;
  bloodType?: string;
  birthday?: string;
  rolCorp?: string;
  colabCorpCode?: string;
  joinDate?: string;
  keyFunctions?: string;
  archievements?: string;
  colabDniCode?: string;
  phone1?: string;
  phone2?: string;
  emergencyContact?: string;
  bank?: string;
  bankAccountNumber?: string;
  bankAccountType?: string;
  address?: string;
  area?: string;
  idSupervisor?: string;

  keyFunction?: string[]; //  nuevo  array
  archievement?: string[]; // nuevo array logros
  isActive?: boolean;  //nuevo atributo
  leaveDate?: string; //nuevo atributo agregado


};

export type CombinedUser = {
  id: string;
  name: string;
  email: string;
  profile: Profile | null;
  avatarUrl: string; // 
};

export async function getLoggedInUserWithProfile(): Promise<CombinedUser> {
  const user = await account.get();

  const profiles = await databases.listDocuments(databaseId, collectionId);
  const profile = profiles.documents.find(p => p.userId === user.$id) as Profile | undefined;

  const avatarUrl = getUserAvatarUrl(user);

  return {
    id: user.$id,
    name: user.name,
    email: user.email,
    profile: profile || null,
    avatarUrl,
  };
}
